import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "!flex-1 h-full bg-gray-100" }, null, -1)
const _hoisted_2 = { class: "shrink-0 w-full h-full bg-white py-3" }
const _hoisted_3 = { class: "relative flex-1" }
const _hoisted_4 = { class: "absolute inset-0 overflow-y-auto -my-1" }
const _hoisted_5 = { class: "overflow-hidden" }
const _hoisted_6 = { class: "!flex-1 line-clamp-1" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "px-3" }

import { computed, onMounted, PropType, Ref, ref } from 'vue';
import { debounce } from 'lodash';
import Draggable from 'vuedraggable';
import { FilePondOptions } from 'filepond';
import { useQueryClient } from 'vue-query';

import { api } from '@/services';
import {
  useGetInspectionImagesByInspectionQuery,
} from '@/entities/inspection/hooks';

import { Inspection } from '@/entities/inspection/types';
import { InspectionGroup } from '@/entities/inspection-group/types';
import { InspectionImage } from '@/entities/inspection-image/types';

import {
  NkDivider,
  NkFilePond,
  NkGroup,
  NkIcon,
  NkStack,
} from '@/core/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageAutoAssembler',
  props: {
  inspection: {
    type: Number as PropType<Inspection['id']>,
    default: null,
  },
  inspectionGroup: {
    type: Number as PropType<InspectionGroup['id']>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const fileUploadErrorTimer: any = ref(null);

const queryClient = useQueryClient();

const canvasImages: Ref<InspectionImage[]> = ref([]);

const inspectionQueryData = computed(() => ({ id: props.inspection }));
const hasInspection = computed(() => !!inspectionQueryData.value.id);

useGetInspectionImagesByInspectionQuery(inspectionQueryData, {
  enabled: hasInspection,
  initialData: () => [],
  onSuccess: (data) => {
    canvasImages.value = data;
  },
});

const inspectionFileDropzoneRef = ref<typeof NkFilePond>();

const isUploadingImage = ref<boolean>(false);

const getCroppedName = (name = '') => `${ name.slice(0, 15) }${ name.length > 15 ? '...' : '' }`;

const handleFileUpload = debounce(() => {
  const files = inspectionFileDropzoneRef.value?.filePond.getFiles();
  const formData = new FormData();

  if (files && files.length) {
    files.map(o => o.file).forEach(o => formData.append('files[]', o));

    api.post(`/inspections/${ props.inspection }/upload`, formData, {params: {assemble: 1}})
      .then(() => {
        queryClient.refetchQueries(['inspection-images-by-inspection', inspectionQueryData]);
      })
      .catch((e) => {
        fileUploadErrorTimer.value = setTimeout(() => {
          fileUploadErrorTimer.value = null;
        }, 7000);
      })
      .finally(() => {
          isUploadingImage.value = false;
          inspectionFileDropzoneRef.value?.filePond.removeFiles();
        },
      );
  }
}, 200);

const assemble = () => {
  api.get(`/inspections/${ props.inspection }/assemble`, {params: {ids: canvasImages.value.map(e => e.id).join(',')}})
}

onMounted(() => {
  inspectionFileDropzoneRef.value?.filePond._pond.setOptions({
    server: {
      process: handleFileUpload,
    },
  } as FilePondOptions);
});

return (_ctx: any,_cache: any) => {
  const _component_ElAlert = _resolveComponent("ElAlert")!

  return (_openBlock(), _createBlock(_unref(NkGroup), {
    spacing: 0,
    class: "h-full",
    noWrap: ""
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(NkStack), {
          class: "h-full",
          justify: "between"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(Draggable), {
                    modelValue: canvasImages.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((canvasImages).value = $event)),
                    "ghost-class": "draggable-ghost",
                    class: "divide-y divide-gray-300",
                    group: "inspectionImagesData",
                    handle: ".handle",
                    "item-key": "id",
                    ondragend: assemble
                  }, {
                    item: _withCtx(({element}) => [
                      _createVNode(_unref(NkGroup), {
                        class: "h-[42px] items-center py-1 select-none px-3 cursor-pointer group hover:bg-gray-50",
                        noWrap: "",
                        position: "apart",
                        title: element.originalName
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NkGroup), {
                            class: "h-full !flex-1",
                            noWrap: "",
                            position: "apart"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NkGroup), {
                                noWrap: "",
                                class: "!flex-1"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NkIcon), {
                                    class: "handle cursor-grab",
                                    name: "NkDragIndicator"
                                  }),
                                  _createElementVNode("span", _hoisted_6, _toDisplayString(element.originalName), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("img", {
                                src: element.assemblerThumbnail,
                                alt: element.originalName,
                                class: "w-[64px] h-full object-cover"
                              }, null, 8, _hoisted_7)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["title"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ]),
            _createVNode(_unref(NkDivider)),
            _createElementVNode("div", _hoisted_8, [
              (fileUploadErrorTimer.value)
                ? (_openBlock(), _createBlock(_component_ElAlert, {
                    key: 0,
                    "show-icon": "",
                    type: "error",
                    title: _ctx.$t('notification.error'),
                    onClose: _cache[1] || (_cache[1] = ($event: any) => (fileUploadErrorTimer.value = null))
                  }, null, 8, ["title"]))
                : _createCommentVNode("", true),
              _createVNode(_unref(NkFilePond), {
                ref_key: "inspectionFileDropzoneRef",
                ref: inspectionFileDropzoneRef,
                options: {
              allowImagePreview: false,
              storeAsFile: true,
              name: 'files[]',
              immediate: false,
              allowMultiple: true,
              acceptedFileTypes: ['image/*'],
              maxParallelUploads: 50,
            }
              }, null, 512)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})